import { Skeleton } from '@shared/components/shadcn';

function OfferPrimaryLoading() {
  return (
    <div
      className="flex flex-col md:justify-center h-full pt-10 pb-12 px-6 md:p-20 md:pr-15 bg-foreground dark:bg-container-base text-foreground-inverse"
      data-testid="offer-primary-loading"
    >
      {/* Logo */}
      <div className="mb-5 md:mb-8">
        <Skeleton className="w-12 h-10 md:w-16 md:h-13 bg-background/10 dark:bg-foreground/10" />
      </div>

      {/* Text Content */}
      <div className="my-2">
        {/* Title - "A welcome from us" */}
        <Skeleton className="h-6 w-40 bg-background/10 dark:bg-foreground/10 mb-2" />

        {/* Description */}
        <Skeleton className="h-12 w-125 max-w-full bg-background/10 dark:bg-foreground/10" />

        {/* Valid until badge */}
        <div className="inline-block mt-5">
          <Skeleton className="h-5 w-32 bg-background/10 dark:bg-foreground/10 rounded-md" />
        </div>
      </div>

      {/* Image - hidden on mobile */}
      <div className="hidden md:block relative max-w-132.5 w-full aspect-[530/280] mt-10 md:mt-20 mx-auto">
        <Skeleton className="absolute inset-0 bg-background/10 dark:bg-foreground/10 rounded-2xl" />
      </div>
    </div>
  );
}

export { OfferPrimaryLoading };
